import React, { Component} from "react";
// Styles
import "./NextLevelView.scss";


// Components
import HeaderView from "components/HeaderView";
// import Next from 'static/img/next.svg'
import  NextLevel from "views/NextLevel/NextLevel";

class NextLevelView extends Component {

  render() {
    return (
      <>
      <div className="level-view">
      <HeaderView/>
      < NextLevel>
       </NextLevel>
    </div>
      </>
    );
  }
}
export default NextLevelView;
